
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Button - More info","xmlns":"http://www.w3.org/2000/svg","width":"43.612","height":"43.612"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 1","cx":"17.5","cy":"17.5","r":"17.5","transform":"translate(4 4)","fill":"transparent"}}),_c('path',{attrs:{"data-name":"Path 7165","d":"M21.806 0a21.806 21.806 0 1021.806 21.806A21.806 21.806 0 0021.806 0zm0 39.978a18.172 18.172 0 1118.172-18.172 18.172 18.172 0 01-18.172 18.172z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Path 7166","d":"M21.806 17.627a1.817 1.817 0 00-1.817 1.817v12.357a1.817 1.817 0 103.634 0V19.444a1.817 1.817 0 00-1.817-1.817zm0-7.45a1.926 1.926 0 00-1.854 1.892v.291a1.708 1.708 0 001.854 1.709 1.89 1.89 0 001.817-1.817v-.44a1.635 1.635 0 00-1.817-1.636z","fill":"#fff"}})])
          )
        }
      }
    